import ProfileModal from './ProfileModal';
import ProfileModalContainer from './ProfileModalContainer';

export {ProfileModalContainer};
export default ProfileModal;
